import React, { Component } from 'react';

import InputSelect from '../../common/InputSelect/InputSelect';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';

import StyledStatsView from './styles/StyledStatsView';


class StatsView extends Component {
  componentDidMount() {
    const { 
      modalData,
      getOfficesDD, getStats,
    } = this.props;

    getOfficesDD();
    if (modalData.defaultOffice !== null) {
      getStats(modalData.defaultOffice)
    }
  }

  render() {
    const { 
      modalData, statsData, officesDDData,
      handleSelectOffice,
    } = this.props;
    return (
      <StyledStatsView>
        <div className="stats-view--header">
          Statistiky
        </div>
        <div className="stats-view--input">
          <div className="stats-view--input-label">
            Pobočka
          </div>
          <InputSelect
            options={officesDDData.data}
            onChange={(selected) => handleSelectOffice(selected)}
            value={modalData.selectedOffice}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            isLoading={officesDDData.isLoading}
            placeholder="Zvolte pobočku"
            noOptionsMessage={() => 'Žádné pobočky'}
            loadingMessage={() => 'Načítám'}
          />
        </div>
        <div className="stats-view--table--header--wrapper">
          <div className="stats-view--table--header">
            <div className="stats-view--table--header-item stats-view--table--id">Id</div>
            <div className="stats-view--table--header-item stats-view--table--name">Název</div>
            <div className="stats-view--table--header-item stats-view--table--desk">Přepážky</div>
            <div className="stats-view--table--header-item stats-view--table--clients">Odbavených</div>
            <div className="stats-view--table--header-item stats-view--table--max-len">Maximální doba čekání</div>
            <div className="stats-view--table--header-item stats-view--table--wait-cli">Čekajících klientů</div>
            <div className="stats-view--table--header-item stats-view--table--wait-avg">Průměrná doba čekání</div>
            <div className="stats-view--table--header-item stats-view--table--last">Poslední vyvolaný</div>
          </div>
        </div>

        { statsData.isLoading  &&
          <div className="stats-view--table--laoder">
            <LoadingSpinner
              text="Načítám statistiky"
              textSize={1}
              spinnerSize={20}
              spinnerFat={4}
            />
          </div>
        }

        { !statsData.isLoading &&
          <div className="stats-view--table--data">
            { statsData.data.map((item, index) => (
              <div key={index} className={'stats-view--table--row stats-view--table--row--' + (index % 2 === 0 ? 'even' : 'odd')}>
                <div className="stats-view--table--header-sm">Id:</div>
                <div className="stats-view--table--item stats-view--table--id">{item.service_id}</div>
                <div className="stats-view--table--header-sm">Název:</div>
                <div className="stats-view--table--item stats-view--table--name">{item.web_order_name}</div>
                <div className="stats-view--table--header-sm">Přepážky:</div>
                <div className="stats-view--table--item stats-view--table--desk">{item.open_desks}</div>
                <div className="stats-view--table--header-sm">Odbavených:</div>
                <div className="stats-view--table--item stats-view--table--clients">{item.served_clients}</div>
                <div className="stats-view--table--header-sm">Maximální doba čekání:</div>
                <div className="stats-view--table--item stats-view--table--max-len">{Math.round((item.waiting_max_length / 60)) + ' min'}</div>
                <div className="stats-view--table--header-sm">Čekajících klientů:</div>
                <div className="stats-view--table--item stats-view--table--wait-cli">{item.waiting_clients}</div>
                <div className="stats-view--table--header-sm">Průměrná doba čekání:</div>
                <div className="stats-view--table--item stats-view--table--wait-avg">{Math.round((item.waiting_avg_length / 60)) + ' min'}</div>
                <div className="stats-view--table--header-sm">Poslední vyvolaný:</div>
                <div className="stats-view--table--item stats-view--table--last">{item.last_number === null || item.last_number === 0 ? '-' : item.last_number}</div>
              </div>
            ))}
          </div>
        }
      </StyledStatsView>
    );
  }
}

export default StatsView;



// WEBPACK FOOTER //
// ./src/components/Stats/StatsView.js